import React, { useState, useEffect } from 'react';

interface Tag {
  id: number;
  name: string;
}

interface TagManagerProps {
  selectedTags: string[];
  onTagsChange: (tags: string[]) => void;
  disabled?: boolean;
}

const TagManager: React.FC<TagManagerProps> = ({
  selectedTags,
  onTagsChange,
  disabled = false,
}) => {
  const [allTags, setAllTags] = useState<Tag[]>([]);
  const [newTagInput, setNewTagInput] = useState("");

  useEffect(() => {
    fetchAllTags();
  }, []);

  const fetchAllTags = async () => {
    try {
      const response = await fetch('/api/admin/guests/tags/all');
      if (response.ok) {
        const tags = await response.json();
        setAllTags(tags);
      }
    } catch (error) {
      console.error('Error fetching tags:', error);
    }
  };

  const handleAddTag = (tagName: string) => {
    const trimmed = tagName.trim();
    if (trimmed && !selectedTags.includes(trimmed)) {
      onTagsChange([...selectedTags, trimmed]);
      setNewTagInput("");
    }
  };

  const handleRemoveTag = (tagName: string) => {
    onTagsChange(selectedTags.filter(t => t !== tagName));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag(newTagInput);
    }
  };

  const filteredSuggestions = allTags
    .filter(tag =>
      !selectedTags.includes(tag.name) &&
      tag.name.toLowerCase().includes(newTagInput.toLowerCase())
    )
    .slice(0, 5);

  const hasMatchingSuggestions = filteredSuggestions.length > 0;

  return (
    <div className="form-group-modern">
      <label>Tags</label>
      <div className="tags-container">
        {selectedTags.map((tagName) => (
          <div key={tagName} className="tag-chip">
            <span>{tagName}</span>
            <button
              type="button"
              onClick={() => handleRemoveTag(tagName)}
              className="tag-remove"
              disabled={disabled}
            >
              ×
            </button>
          </div>
        ))}
      </div>

      <div className="tag-input-wrapper">
        <div className="tag-input-group">
          <input
            type="text"
            value={newTagInput}
            onChange={(e) => setNewTagInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Ajouter un tag..."
            className="modal-input tag-input"
            disabled={disabled}
          />
          <button
            type="button"
            onClick={() => handleAddTag(newTagInput)}
            className="modern-btn secondary small"
            disabled={!newTagInput.trim() || disabled}
          >
            Ajouter
          </button>
        </div>

        {newTagInput.trim() && (
          <div className="tag-suggestions-dropdown">
            {filteredSuggestions.map((tag) => (
              <button
                key={tag.id}
                type="button"
                onClick={() => handleAddTag(tag.name)}
                className="tag-suggestion-item"
              >
                {tag.name}
              </button>
            ))}
            {!hasMatchingSuggestions && (
              <div className="no-tag-suggestions">
                Nouveau tag: "{newTagInput.trim()}"
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TagManager;
